import banner from "../img/banner.png"
import { useSpring, animated } from 'react-spring'


export const Banner = () =>{

    const styles = useSpring({
        from: { background: "#f08484" },
        to: [
          { background: "#F53838" },
          { background: "#f08484"},
        ],
        config: { duration: "1500" },
        loop:true
    })

    const styles1 = useSpring({
        from: { transform: "translateY(10%)" },
        to: [
          { transform: "translateY(0%)" },
          { transform: "translateY(10%)"},
        ],
        config: { duration: "4500" },
        loop:true
      })
      
    return(
        <section className="banner container1 flex">
            <div className="banner-left" >
                <h1>Want anything to be easy with <div className="big">LaslesVPN.</div></h1>
                <p> Provide a network for all your needs with ease and fun using LaslesVPN <br/>discover interesting features from us. </p>
                <animated.div style={styles} className="main-button">Get Started</animated.div>
            </div>
            <animated.div style={styles1}><img src={banner} /></animated.div>
        </section>

        
    )
}